import { Modal, Button } from 'iglooform';
import { useIntl } from 'react-intl';

interface OtpVerifyModalProps {
  visible: boolean;
  onContinue: () => void;
}

export const OtpVerifyModal = ({
  visible,
  onContinue,
}: OtpVerifyModalProps) => {
  const { formatMessage } = useIntl();
  return (
    <Modal
      title={formatMessage({
        id: 'Please verify your email',
        defaultMessage: 'Please verify your email',
      })}
      visible={visible}
      closable={false}
      footer={[
        <Button
          key="continue"
          style={{ width: '159px' }}
          type="primary"
          onClick={onContinue}
        >
          {formatMessage({ id: 'Continue', defaultMessage: 'Continue' })}
        </Button>,
      ]}
    >
      <p>
        {formatMessage({
          id: 'To continue using Ignite, please verify your email address first.',
          defaultMessage:
            'To continue using Ignite, please verify your email address first.',
        })}
      </p>
    </Modal>
  );
};
